import $ from 'jquery'

/**
 * Similar to $.closest(), traverses up the DOM tree and returns the first
 * element that matches the given selector (including the given element).
 * Unlike $.closest(), will not traverse past the given stopSelector
 */
function closestUntil (el, selector, stopSelector) {
  function check ($el) {
    if ($el.length === 0) {
      return $([])
    }
    
    if ($el.is(selector)) {
      return $el
    }

    if ($el.is(stopSelector)) {
      return $([])
    }

    return check($el.parent())
  }

  return check($(el))
}

export default closestUntil
